import React from 'react';
import Header from './Header';
import logo from '../logo.svg';

const getImagemUrl = (path) => {
  if (!path) return logo;
  if (path.startsWith('https://')) return path;
  return `https://conexaopix.com.br/docs${path}`;
};

function EmpresasPage({ usuario, empresas, pesquisaEmpresa, setPesquisaEmpresa, pagina, setPagina, empresasFiltradas, empresasPaginadas, totalPaginasFiltradas, handleSelecionarEmpresa, handleSair }) {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} onSair={handleSair} />
      <div className="flex flex-1 flex-col items-center justify-center p-4">
        <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-3xl mt-16 border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold mb-6 text-center text-blue-700">Selecione a Empresa:</h2>
          <div className="mb-6 flex w-full">
            <input
              type="text"
              value={pesquisaEmpresa}
              onChange={e => { setPesquisaEmpresa(e.target.value); setPagina(1); }}
              placeholder="Pesquisar por nome ou ID..."
              className="border rounded px-3 py-2 max-w-xs"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full">
            {empresasPaginadas.map((empresa) => (
              <div
                key={empresa.id}
                className="bg-blue-50 rounded-lg shadow flex flex-col items-center justify-center p-4 cursor-pointer hover:bg-blue-100 transition border border-blue-300 min-w-[160px] min-h-[90px]"
                onClick={() => handleSelecionarEmpresa(empresa)}
              >
                <img
                  src={getImagemUrl(empresa.path_imagem)}
                  alt="Logo"
                  className="w-16 h-16 object-contain rounded mb-2 border shadow bg-white"
                  style={{ background: '#fff' }}
                />
                <span className="text-base font-semibold text-blue-800 text-center break-words">{empresa.fantasia}</span>
                <div className="flex w-full justify-between items-center mt-1">
                  <span className="text-xs text-gray-500">ID: {empresa.id}</span>
                  {empresa.revenda === true && (
                    <span className="text-xs font-bold text-blue-700 ml-2">REVENDA</span>
                  )}
                </div>
              </div>
            ))}
            {empresasPaginadas.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhuma empresa encontrada.</div>
            )}
          </div>
          {totalPaginasFiltradas > 1 && (
            <div className="flex justify-center items-center mt-8 mb-2 w-full">
              {Array.from({ length: totalPaginasFiltradas }, (_, i) => (
                <button
                  key={i + 1}
                  className={`w-10 h-10 flex items-center justify-center rounded transition font-semibold border mx-0.5
                    ${pagina === i + 1 ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-200 hover:bg-blue-50'}`}
                  onClick={() => setPagina(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EmpresasPage; 